import React from "react";
import {
  Grid,
  List,
  ListItem,
  Paper,
  Typography,
} from '@material-ui/core'
import SearchUserDelegate from './SearchUserDelegate';
import { Help } from '@material-ui/icons';
import SubsectionTooltip from '../SubsectionTooltip';

export class Delegates extends React.Component {

  componentDidMount() {
    document.title = "GO | Delegar";
  }

  render() {
    return (
      <React.Fragment>
        <Section
          type='delegate'
          header='Delegar usuario para redactar oficios'
          title='Autorizar a un usuario(s) para que este pueda redactar oficios  nombre del titular o emisor.'
          description='Delegar a:' />
        <Section
          type='reviewer'
          header='Delegar usuario para filtrar oficios'
          title='Delegar usuario para que reciba los oficios antes que el titular y los redirija a las instancias correspondientes.'
          description='Delegar como revisor a:'/>
      </React.Fragment>
    );
  }
}

const Section = props => {
  const { type, title, description, header } = props;
  return(
    <Grid container style={{ marginBottom: 20}}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper className="subsection_container">
          <div>
            <List>
              <ListItem>
                <Grid container justify="space-between">
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography variant="h5" className="subsection_header">{header}
                        <SubsectionTooltip
                           placement="right"
                           title={
                             <React.Fragment>
                               <p>{title}</p>
                             </React.Fragment>
                           }>
                        <Help color="primary" fontSize="small" style={{ paddingTop: 5 }} />
                      </SubsectionTooltip>
                      </Typography>
                    <Typography variant="subtitle2">{description}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <SearchUserDelegate
                      type={type}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </div>
        </Paper>
      </Grid>
    </Grid>
  )
}

Delegates.propTypes = {};
export default Delegates;



// WEBPACK FOOTER //
// ./src/components/containers/Delegate.js